<template>
    <div class="unconnect-note-page">
        <form-component ref="form">
            <title-component>{{ infoMessage }}</title-component>

            <input type="checkbox" id="clientRetreivedWithTransort" v-model="walkToFinish.clientRetreivedWithTransort" class="checkbox">
            <label for="clientRetreivedWithTransort" >Passend vervoer ingezet</label>

            <h4>Overzicht van alarmeringen</h4>
            <table v-if="walkToFinish.notifications.length > 0">
                <thead>
                <tr>
                    <th v-for="col in tableColumns" :key="col" class="table-head">{{ col }}</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="notification in walkToFinish.notifications"
                    :key="notification.id"
                    class="table-row">
                    <td>{{ notification.smartwatchName }}</td>
                    <td>{{ notification.clientInitials }}</td>
                    <td>{{ notification.notificationType }}</td>
                    <td>{{ notification.serverTime | toSimpleDateFormat }}</td>
                </tr>
                </tbody>
            </table>

            <h4>Opmerkingen</h4>
                <textarea placeholder="Voer eventuele opmerkingen in.." v-model="walkToFinish.notes"></textarea>
            <button-component @click.native="finishWalk" :submitted="finishWalkSubmitted">Innemen</button-component>

        </form-component>
    </div>
</template>

<script>
    import { Walk } from "../domain/walk";
    import FormComponent from '@/components/fields/form.component.vue';
    import ButtonComponent from '../components/button.component.vue';
    import TitleComponent from '../components/title.component';
    import { mapGetters } from 'vuex';
    import { RouteName, Viewport } from '../utils/enums';

    export default {
        name: 'unconnect-note-page',
        components: {
            FormComponent,
            ButtonComponent,
            TitleComponent
        },
        data() {
            return {
                walkToFinish: Walk,
                finishWalkSubmitted: false,
                infoMessage: '',
                tableColumns: ['Smartwatch', 'Cliënt', 'Type alarmering', 'Tijdstip alarmering']
            };
        },
        computed: {
            ...mapGetters(['getWalkToFinish']),
        },
        created() {
            this.walkToFinish = this.$store.getters.getWalkToFinish;
            this.createInfoMessage();
            window.scrollTo(0,0);
        },
        methods: {
            createInfoMessage: function() {
                this.infoMessage = 'Smartwatch ' + this.walkToFinish.smartwatch.smartwatchName +
                 ' innemen en ontkoppelen van cliënt ' + this.walkToFinish.client.initials;
            },
            finishWalk: function () {
                this.finishWalkSubmitted = true;
                this.$store.dispatch('FINISH_WALK', this.walkToFinish)
                    .then(response => {
                        if (response.status === 200) {
                                this.$router.push({ name: RouteName.UNCONNECT_COMPLETE });
                        }
                        else {
                            console.error('Er is iets fout gegaan: ' + response);
                            this.finishWalkSubmitted = false;
                        }
                    });
            }
        }
    };
</script>
<style scoped lang="scss">
    textarea {
        resize: none;
        width: 100%;
        height: 40vh;
        border: 1px solid #ccc;
        border-radius: 4px;
        box-sizing: border-box;
        margin-top: 6px;
        margin-bottom: 10px;
        display: block;
        margin-left: auto;
        margin-right: auto;
    }

    .checkbox {
        margin-bottom: 2rem;
    }

    table {
        width: 100%;
        background-color: $white;
        margin-bottom: 2rem;
    }

    .table-head {
        background-color: $primary;
        color: $white;
    }

    th, td {
        text-align: left;
        padding: 8px;
    }

    tr {
        border-radius: 0.25rem;
        height: 4rem;
        box-shadow: 0 -2px 8px 0px rgba(0, 0, 0, 0.1);
        margin-bottom: 1rem;
        overflow: hidden;
        transition: 0.3s ease all;
    }

    tr:hover td {
        background-color: $gray;
        cursor: pointer;
    }

</style>
